import axios from "axios";
import { IImportResponse } from "../pages/importadorProductos/interface/IImportadorProductos";

const { REACT_APP_ENDPOINT } = process.env;
const ENDPOINT = `${REACT_APP_ENDPOINT}/api/ImportadorCarrio/`;

export default class ImportadorProductosService {
  static async descargarTemplate(): Promise<boolean> {
    try {
      const response = await axios.get(`${ENDPOINT}template`, {
        responseType: "blob",
      });

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "Template_Importar_Productos.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error descargando template:", error);
      return false;
    }
  }

  static async importarProductos(formDataFile: {
    file: File[];
  }): Promise<IImportResponse | null> {
    try {
      const local = JSON.parse(
        window.localStorage.getItem("LocalSession") || "{}",
      );
      const formData = new FormData();

      if (formDataFile.file.length > 0) {
        formData.append("archivo", formDataFile.file[0]);
      }

      formData.append("clienteId", local.clienteId.trim());
      formData.append("contactoId", local.contactoId.toString());

      const response = await axios.post(`${ENDPOINT}importar`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error importando productos:", error);
      return null;
    }
  }

  static async confirmarImportacion(parentId: string): Promise<any> {
    try {
      const local = JSON.parse(
        window.localStorage.getItem("LocalSession") || "{}",
      );

      const response = await axios.post(`${ENDPOINT}confirmar`, {
        clienteId: local.clienteId.trim(),
        contactoId: local.contactoId.toString(),
        parentId,
      });

      return response.data;
    } catch (error) {
      console.error("Error confirmando importación:", error);
      throw error;
    }
  }
}
